<template>
  <div class="listing">
    <transition name="animate-carousel">
      <scene-wrapper :items="listing"
                     v-if="animationState"></scene-wrapper>
    </transition>
    <splash-animation v-if="!animationState"
                      :isParentMounted="isComponentMounted"
                      @intro-status-changed="changeStatus"></splash-animation>
  </div>
</template>

<script>
  import SplashAnimation from './SplashAnimation'
  import Interface from './Interface'
  import SceneWrapper from './SceneWrapper.vue'

  export default{
    data(){
      return {
        hasLoaded: false,
        isAnimationOver: false,
        isComponentMounted: false,
        listing: []
      }
    },
    components: {
      'splash-animation': SplashAnimation,
      'ui-interface': Interface,
      'scene-wrapper': SceneWrapper
    },
    computed: {
      hideAnimation(){
        return this.hasLoaded && this.isAnimationOver;
      },
      animationState(){
        return this.$store.state.hasApplicationLoaded;
      }
    },
    watch: {
      listing(){
        this.initListing(this.listing);
      }
    },
    methods: {
      animationOver(){
        this.$store.state.hasApplicationLoaded = true;
      },
      changeStatus(){
        this.isAnimationOver = true;
        this.animationOver();
      },
      initListing(){
        this.hasLoaded = true;
      }
    },
    mounted(){
      this.listing = this.$store.state.sceneListing;
      this.$store.state.interface.isWhite = false;
      this.isComponentMounted = true;

      // @TODO come mai viene chiamato due volte?
      eventTracking.send({
        category: 'HomePage',
        action: 'View'
      });


    },
    created(){
      var vm = this;
      var url = document.querySelector('#root').getAttribute('data-endpoint-listing');

      function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      var hasCookie = getCookie('iguzzini-dle');
      if (hasCookie) {
        this.$store.state.hasTutorialPlayed = true;
      }

      if (vm.$store.state.sceneListing.length) {
        vm.listing = vm.$store.state.sceneListing;
      }
      else {
        //var myHeaders = new Headers();
        //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));

        fetch(url, {
          //credentials: "include"//,
          //headers: myHeaders
        })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function (data) {
            if (data.header.success) {
              vm.listing = data.data;
            }
            else {
              vm.$router.push('/');
            }
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Listing.vue